import { Pipe, PipeTransform } from '@angular/core';
import { AnnualReportStep, AutofillOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Pipe({
    name: 'inReportSteps',
})
export class InReportStepsPipe implements PipeTransform {
    transform(value: string, args: AnnualReportStep[]): boolean {
        const modifiedValue = value === AutofillOptions.cashflow ? AnnualReportStep.CFS : value.toUpperCase();

        if (args.includes(modifiedValue as AnnualReportStep)) {
            return true;
        }

        return false;
    }
}
